module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_01_770_280_th-bbc6b3149bac91e5ffff7a72183bd0e2.jpg";